import { useEffect } from 'react';

const SEOHead = ({ 
  title = "Nukard - Seu site/aplicativo personalizado, sem complicação",
  description = "Nukard - Soluções digitais acessíveis, rápidas e personalizadas para pequenos negócios e profissionais autônomos. Seu site/aplicativo personalizado, sem complicação.",
  keywords = "sites personalizados, aplicativos, pequenos negócios, soluções digitais, desenvolvimento web",
  canonical = "https://nukard.com.br/",
  ogImage = "/og-image.jpg",
  ogImageAlt = "Nukard - Soluções Digitais Logo"
}) => {
  
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords);
    }
    
    // Update canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', canonical);
    }
    
    // Update Open Graph meta tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', title);
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', description);
    }
    
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', canonical);
    }
    
    const ogImageTag = document.querySelector('meta[property="og:image"]');
    if (ogImageTag) {
      ogImageTag.setAttribute('content', `${window.location.origin}${ogImage}`);
    }
    
    // Update Twitter meta tags
    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', title);
    }
    
    const twitterDescription = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', description);
    }
    
    const twitterUrl = document.querySelector('meta[property="twitter:url"]');
    if (twitterUrl) {
      twitterUrl.setAttribute('content', canonical);
    }
    
    const twitterImage = document.querySelector('meta[name="twitter:image"]');
    if (twitterImage) {
      twitterImage.setAttribute('content', `${window.location.origin}${ogImage}`);
    }
    
    // Update Open Graph image alt text
    const ogImageAltTag = document.querySelector('meta[property="og:image:alt"]');
    if (ogImageAltTag) {
      ogImageAltTag.setAttribute('content', ogImageAlt);
    }
    
    const twitterImageAlt = document.querySelector('meta[name="twitter:image:alt"]');
    if (twitterImageAlt) {
      twitterImageAlt.setAttribute('content', ogImageAlt);
    }
    
  }, [title, description, keywords, canonical, ogImage, ogImageAlt]);
  
  return null; // This component doesn't render anything visible
};

export default SEOHead;
